import { useState, useContext, useEffect, useMemo } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Card,
  CardBody,
  Container,
} from "reactstrap";
import { Plus } from "react-feather";

import SharedDataContext from "../../../_helper/SharedData";

import { Breadcrumbs, Btn } from "../../../AbstractElements";

import ServiceCityConfigForm from "../Forms/ServiceCityConfigForm";
import ServiceCityTable from "../Tables/ServiceCityTable";
import { getServiceCityTableData } from "../../../Services/ServiceCity.service";
import { showAlert } from "../../../Services/Shared.service";
import { size } from "lodash";
import CustomSearchFilter from "../../Common/Component/CustomSearchFilter";

export const ServiceCityFlow = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [serviceCityData, setServiceCityData] = useState([])
  const [pagination, setPagination] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const [isRefresh, setIsRefresh] = useState(false);
  const { cityData, trgiggerRefresh } =
    useContext(SharedDataContext);

  const [searchData, setSearchData] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterData, setFilterData] = useState([]);

  const filteredData = useMemo(() => {
    if (!searchData) return serviceCityData;
    const query = searchData.toLowerCase();
    return serviceCityData.filter(item =>
      (item.name && item.name.toLowerCase().includes(query)) ||
      (item.cityCode && item.cityCode.toLowerCase().includes(query)) ||
      (item.aggregatorCompanyName && item.aggregatorCompanyName.toLowerCase().includes(query)) ||
      (item.companyName && item.companyName.toLowerCase().includes(query)) ||
      (item.placeOfSupply && item.placeOfSupply.toLowerCase().includes(query))
    );
  }, [serviceCityData, searchData]);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const onAddClick = () => {
    setEditId(null);
    setIsOpen(true);
  };

  const onEditClick = (id) => {
    setEditId(id);
    setIsOpen(true);
  };

  useEffect(() => {
    fetchData()

  }, [])
  useEffect(() => {
    fetchData()

  }, [pagination, rowsPerPage])
  const triggerRefresh = () => {
    setIsRefresh(!isRefresh);
  };
  const onChangePage = (page) => {
    console.log("page", page);
    setPagination(page - 1);
  };
  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };

  const fetchData = () => {
    let obj = {
      page: pagination,
      size: rowsPerPage,
    }
    getServiceCityTableData(obj).then(
      (res) => {
        if (res.data) {
          setServiceCityData(res.data.searchResponse)
          console.log("fdfdf", res.data)
          setPaginationTotalRows(res.data.count)
          disableLoaders();
        }
      }
    ).catch((err) => {
      disableLoaders();
      showAlert("error", err.response?.data?.message
        ? err.response.data.message : "Something went wrong");
    })
  }
  const disableLoaders = () => {
    setLoader(false);
  };

  return (
    <div>
      <Breadcrumbs
        parent="Configuration"
        subParent="Service City"
        mainTitle="Service City"
        style={{ padding: "0px" }}
        span3={
          <div className="d-flex align-items-center justify-content-end gap-3" style={{ width: "100%" }}>
            <div style={{ minWidth: "250px" }}>
              <CustomSearchFilter
                searchData={searchData}
                setSearchData={setSearchData}
                setFilterData={setFilterData}
                setFilterType={setFilterType}
                placeholder="Search Service City"
              />
            </div>
            <div
              style={{
                color: "rgba(57, 181, 74, 1)",
                border: "1px solid rgba(57, 181, 74, 1)",
                borderRadius: "10px",
                backgroundColor: "rgba(225, 244, 228, 1)",
                height: "40px",
                minWidth: "140px",
                fontSize: "15px",
                padding: "0 20px",
                textTransform: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                cursor: "pointer",
                fontWeight: "600",
                whiteSpace: "nowrap"
              }}
              onClick={onAddClick}
            >
              <Plus size={18} />
              Add Service City
            </div>
          </div>
        }
      />

      <ServiceCityTable
        serviceCityData={filteredData}
        isRefresh={isRefresh}
        trgiggerRefresh={triggerRefresh}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        paginationTotalRows={searchData ? filteredData.length : paginationTotalRows}
        loader={loader}
        setLoader={setLoader}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        fetchData={fetchData}
        onEditClick={onEditClick}
        pagination={pagination}
      />

      <Modal
        isOpen={isOpen}
        toggle={toggleModal}
        size={"lg"}
        centered
        className="common-modal"
        backdrop="static"
      >
        <ModalHeader toggle={toggleModal} style={{ color: "#41CC7D" }} />

        <ModalBody style={{ paddingBottom: "20px", border: 0 }}>
          <ServiceCityConfigForm
            cityData={cityData}
            editId={editId}
            toggleModal={toggleModal}
            trgiggerRefresh={trgiggerRefresh}
            fetchData={fetchData}
          />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ServiceCityFlow;
